import { useState } from 'react';
import Select from 'react-select';

import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/arrow-down.svg';
import { statusClientOptions } from '../../../config/constants';
import { useNotification } from '../../../hooks/useNotification';
import {
  colourStyles,
  CustomOption,
  CustomSingleValue,
} from '../../../styles/statusDropdownStyle';

type Props = {
  initialStatusValue: string;
  mutation: (arg: any) => void;
  clientId: string;
};

const ClientStatusDropdown = ({
  initialStatusValue,
  mutation,
  clientId,
}: Props) => {
  const { notifySaveSuccess } = useNotification();

  const [status, setStatus] = useState<string>(initialStatusValue);

  const handleChangeStatus = (selectedOption: any) => {
    const newStatus = selectedOption.value;
    setStatus(newStatus);

    mutation({
      variables: {
        key: 'status',
        value: selectedOption.value,
        clientId,
      },
    });

    notifySaveSuccess();
  };

  return (
    <>
      <div className="absolute flex text-xs font-medium">
        <Select
          styles={colourStyles(status, statusClientOptions)}
          components={{
            DropdownIndicator: () => <ArrowDownIcon />,
            IndicatorSeparator: () => null,
            Option: CustomOption,
            SingleValue: CustomSingleValue,
          }}
          options={statusClientOptions}
          onChange={handleChangeStatus}
          id="StatusClient"
          value={statusClientOptions.find((option) => option.value === status)}
          isSearchable={false}
        />
      </div>
    </>
  );
};

export default ClientStatusDropdown;
